import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ScreenLoader } from '@/components/loaders';
import { BillingPreviewToggle } from '@/components/dev/BillingPreviewToggle';
import { useAuthContext } from './useAuthContext';
import { canAccessRestrictedPath, getRestrictedRedirectPath } from './accessControl';



const RequireAuth = () => {
  let {
    auth,
    loading
  } = useAuthContext();
  const location = useLocation();

  if (loading) {
    return <ScreenLoader />;
  }
  const user = auth?.user;

  if (
    auth &&
    !canAccessRestrictedPath(user, location.pathname)
  ) {
    return <Navigate to={getRestrictedRedirectPath(user) || '/'} replace />;
  }

  // The billing preview sits outside the layout chrome on purpose: in the
  // paywalled state the nav and topbar are hidden, and it has to stay
  // reachable there or a tester cannot switch back.
  return auth ? (
    <>
      <BillingPreviewToggle />
      <Outlet />
    </>
  ) : <Navigate to="/auth/login" state={{
    from: location
  }} replace />;
};
export { RequireAuth };
